import styled, { css } from "styled-components";
import { add } from "date-fns";
import { applyOpacity } from "../../../../styles/utils";
import { MonthYearControlsProps } from "../MonthYearControls";
import React from "react";
import { SelectableButton } from "../../../SelectableButton/SelectableButton";
import { today } from "../../../../../utils";
import { useTranslation } from "react-i18next";
export type MonthSelectorProps = Omit<MonthYearControlsProps, "toggleOpen">;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  row-gap: 0.25rem;
`;
const Button = styled(SelectableButton)`
  min-height: 2.5rem;
  width: 6.5rem;
  flex-grow: 1;
  ${props => {
  const disabled = props["aria-disabled"];
  return disabled ? css`
          cursor: not-allowed !important;
          color: ${({
    theme
  }) => applyOpacity(theme.colours.dark, 0.4)} !important;
          box-shadow: none !important;
          border-color: ${({
    theme
  }) => applyOpacity(theme.colours.dark, 0.1)} !important;
        ` : null;
}};
`;
export function MonthSelector({
  monthOffset,
  onChange
}: MonthSelectorProps) {
  const {
    i18n
  } = useTranslation();
  const locale = i18n.language;
  const currentMonth = add(today, {
    months: monthOffset
  }).getMonth();
  const monthButtons = [...Array(12).keys()].map(month => {
    const monthDisplay = new Date(2000, month, 1).toLocaleString(locale, {
      month: "long"
    });
    const offsetDifference = monthOffset + (month - currentMonth);
    const onClick = () => {
      onChange(offsetDifference);
    };
    const selected = month === currentMonth;
    return <Button key={month} {...{
      onClick,
      selected
    }}>
        {monthDisplay}
      </Button>;
  });
  return <Container data-sentry-element="Container" data-sentry-component="MonthSelector" data-sentry-source-file="MonthSelector.tsx">{monthButtons}</Container>;
}
export default MonthSelector;